import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { API_TAB_TYPES } from '../apiconfig.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'lib-form-array-template',
  templateUrl: './form-array-template.component.html',
  styleUrls: ['./form-array-template.component.scss']
})
export class FormArrayTemplateComponent implements OnInit,OnDestroy {

  @Input() arrayformGroup!:FormGroup;
  @Input() formArrayName!:string;
  @Input() arraySubGroup!:FormGroup;
  @Input() label!:string;
  @Input() tabType!:string;
  @Input() currentFormValue:any;

  keyValueGroup!:FormGroup;

  apiTabTypes = API_TAB_TYPES;
  dataTypes = [
    'string',
    'number',
    'boolean',
    'object',
    'double'
  ];

  isKeyExists:boolean = false;
  $destroy:Subject<void> = new Subject();

  constructor(private _fb:FormBuilder){}

  ngOnInit(): void {
  }
  
  get items(){
    return (this.arrayformGroup.get(this.formArrayName) as FormArray);
  }

  removeItem(index:number){
    this.items.removeAt(index);
  }

  addItem(){
    if(this.tabType === this.apiTabTypes.variables){
      this.items.push(this._fb.group({
        key: ['', Validators.required],
        defaultValue: ['', Validators.required],
        type:['',Validators.required]
      }));
    }else if(this.tabType === this.apiTabTypes.queryParems){
      this.items.push(this._fb.group({
        key: ['', Validators.required],
        value: ['', Validators.required],
        type:['',Validators.required]
      }));
    }else{
    this.items.push(this._fb.group({
      key:['',Validators.required],
      value:['',Validators.required]
    }));
  }
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }
}
